import { Transaction, User, Auth, Query, Predicate, Relation, Direction } from 'olympe';
import AndritzUser from '../../../../models/AndritzUser';

const olympeRoleRelation = new Relation('ff022000000000000005', Direction.DESTINATION);
const olympeBaseRole = 'ff011000000000000001';

export const createAndritzUser = (userName, password, userFullName, role) => {
    const transaction = new Transaction();

    // -- CREATE AUTH DATA
    const authData = Auth.generateSRPData(userName, password);

    // CREATE Andritz User PROPERTIES
    const andritzUserProperties = new Map()
        .set(AndritzUser.fullnameProp, userFullName)
        .set(AndritzUser.usernameProp, userName);

    // CREATE ANDRITZ USER
    const andritzUser = transaction.create(AndritzUser, andritzUserProperties);

    // -- RELATE TO ROLE
    transaction.createRelation(AndritzUser.roleRel, andritzUser, role);

    // CREATE OLYMPE USER PROPERTIES
    const userProperties = new Map()
        .set(User.loginProp, userName)
        .set(User.saltProp, authData.salt)
        .set(User.verifierProp, authData.verifier);

    // CREATE OLYMPE USER
    const olympeUser = transaction.create(User, userProperties);

    // Ensure the user is added in the base role (to give him access to the app)
    transaction.createRelation(olympeRoleRelation, olympeBaseRole, olympeUser);

    // EXECUTE TRANSACTION
    return transaction.execute();
};

export const updateAndritzUser = async (context, andritzUser, password, newRole, newFullName) => {
    const andritzUserName = andritzUser.getUsername();
    const andritzUserFullName = andritzUser.getFullname();

    const transaction = new Transaction(true);

    // UPDATE FULLNAME
    if (andritzUserFullName !== newFullName) {
        transaction.update(andritzUser, AndritzUser.fullnameProp, newFullName);
    }

    // UPDATE PASSWORD
    if (password) {
        const authData = Auth.generateSRPData(andritzUserName, password);
        const user = (
            await Query.instancesOf(User)
                .filter(Predicate.equals(User.loginProp, andritzUserName))
                .execute()
        ).getFirst();

        // CREATE USER PROPERTIES
        const userProperties = new Map()
            .set(User.saltProp, authData.salt)
            .set(User.verifierProp, authData.verifier);

        // UPDATE OLYMPE USER
        transaction.multiUpdate(user, userProperties);
    }

    // GET CURRENT ROLE
    const currentRole = await andritzUser.followSingle(AndritzUser.roleRel).execute();

    if (currentRole.getTag() !== newRole.getTag()) {
        // -- Delete role
        transaction.deleteRelation(AndritzUser.roleRel, andritzUser, currentRole);
        // -- Relate to role
        transaction.createRelation(AndritzUser.roleRel, andritzUser, newRole);
    }

    // EXECUTE TRANSACTION
    return transaction.execute();
};
